import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    // presupuestoNumero: '',
    cliente: '',
    accion: '',
    tipoPresupuesto: '',
    canal: '',
    subcliente: '',
    descripcion: '',
    descripcionAdicionales: '',
    requerimientosDisenio: '',
    formaEntregaEditable: false,
    formaEntregaDigital: false,
    formaEntregaImpresion: false,
    formaEntregaAdaptacion: false,
    formaEntregaIndefinida: false,
    formaEntregaOtros: false,
    formaEntregaOtrosDescripcion: '',
    fechaEntregaMuestra: '1900-01-01',
    fechaEntregaOriginales: '1900-01-01',
    fechaImplementacion: '1900-01-01',
    especificacionesProduccion: '',

    /* Mecánica promocional */
    accionPuntoVenta: false,
    accionConsumidorFinal: false,
    accionFuerzaVenta: false,
    accionOtros: false,
    accionOtrosDescripcion: '',
    titular: '',
    mecanica: '',
    premios: '',
    pieLegal: '',
    piezas: '',

    responsable: '',
    usuario: '',
    isCerrado: false,
    fechaCierre: '1900-01-01',
    usuarioCierre: '',

    adicionales: [],
    cambios: [],
    links: [],
    marcas: [],
    imagenes: [],
    muestras: [],
    originales: [],
    presupuestosInternos: [],
    tiposDisenios: [],
    usuarios: [],

    briefCambios: {},

    briefDatos: {},
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, briefId) {
        state.id = briefId;
        // state.presupuestoNumero = '';
        state.cliente = '';
        state.accion = '';
        state.tipoPresupuesto = '';
        state.canal = '';
        state.subcliente = '';
        state.descripcion = '';
        state.descripcionAdicionales = '';
        state.requerimientosDisenio = '';
        state.formaEntregaEditable = false;
        state.formaEntregaDigital = false;
        state.formaEntregaImpresion = false;
        state.formaEntregaAdaptacion = false;
        state.formaEntregaIndefinida = false;
        state.formaEntregaOtros = false;
        state.formaEntregaOtrosDescripcion = '';
        state.fechaEntregaMuestra = '1900-01-01';
        state.fechaEntregaOriginales = '1900-01-01';
        state.fechaImplementacion = '1900-01-01';
        state.especificacionesProduccion = '';

        /* Mecánica promocional */
        state.accionPuntoVenta = false;
        state.accionConsumidorFinal = false;
        state.accionFuerzaVenta = false;
        state.accionOtros = false;
        state.accionOtrosDescripcion = '';
        state.titular = '';
        state.mecanica = '';
        state.premios = '';
        state.pieLegal = '';
        state.piezas = '';

        state.responsable = '';
        state.usuario = '';
        state.isCerrado = false;
        state.fechaCierre = '1900-01-01';
        state.usuarioCierre = '';

        state.adicionales = [];
        state.cambios = [];
        state.imagenes = [];
        state.links = [];
        state.marcas = [];
        state.muestras = [];
        state.originales = [];
        state.presupuestosInternos = [];
        state.tiposDisenios = [];
        state.usuarios = [];

        state.briefDatos = {};
    },
    'SET_TIPOS_DISENIOS' (state, tiposDisenios) {
        state.tiposDisenios = tiposDisenios
            .map(tipoDisenio => ({
                ...tipoDisenio,
                selected: false
            }))
            .sort(function(a, b){
                let x = a.nombre.toLowerCase().trim();
                let y = b.nombre.toLowerCase().trim();
                if (x < y) { 
                    return -1; 
                }
                if (x > y) {
                    return 1;
                }
                return 0;
            });
    },
    'SET_BRIEF'(state, brief) {
        // state.presupuestoNumero = brief.presupuestoNumero;
        state.cliente = brief.cliente;
        state.accion = brief.accion;
        state.tipoPresupuesto = brief.tipoPresupuesto;
        state.canal = brief.canal;
        state.subcliente = brief.subcliente;
        state.descripcion = brief.descripcion;
        state.descripcionAdicionales = brief.descripcionAdicionales;
        state.requerimientosDisenio = brief.requerimientosDisenio;
        state.formaEntregaEditable = (/true/i).test(brief.formaEntregaEditable);
        state.formaEntregaDigital = (/true/i).test(brief.formaEntregaDigital);
        state.formaEntregaImpresion = (/true/i).test(brief.formaEntregaImpresion);
        state.formaEntregaAdaptacion = (/true/i).test(brief.formaEntregaAdaptacion);
        state.formaEntregaIndefinida = (/true/i).test(brief.formaEntregaIndefinida);
        state.formaEntregaOtros = (/true/i).test(brief.formaEntregaOtros);
        state.formaEntregaOtrosDescripcion = brief.formaEntregaOtrosDescripcion;
        state.fechaEntregaMuestra = moment(brief.fechaEntregaMuestra).format('YYYY-MM-DD HH:mm');
        state.fechaEntregaOriginales = moment(brief.fechaEntregaOriginales).format('YYYY-MM-DD HH:mm');
        state.fechaImplementacion = moment(brief.fechaImplementacion).format('YYYY-MM-DD HH:mm');
        state.especificacionesProduccion = brief.especificacionesProduccion;

        /* Mecánica promocional */
        state.accionPuntoVenta = (/true/i).test(brief.accionPuntoVenta);
        state.accionConsumidorFinal = (/true/i).test(brief.accionConsumidorFinal);
        state.accionFuerzaVenta = (/true/i).test(brief.accionFuerzaVenta);
        state.accionOtros = (/true/i).test(brief.accionOtros);
        state.accionOtrosDescripcion = brief.accionOtrosDescripcion;
        state.titular = brief.titular;
        state.mecanica = brief.mecanica;
        state.premios = brief.premios;
        state.pieLegal = brief.pieLegal;
        state.piezas = brief.piezas;

        state.responsable = brief.responsable;
        state.usuario = brief.usuario;
        state.isCerrado = (/true/i).test(brief.isCerrado);
        state.fechaCierre = moment(brief.fechaCierre).format('YYYY-MM-DD HH:mm');
        state.usuarioCierre = brief.usuarioCierre;

        state.adicionales = brief.adicionales
            .sort((a, b) => new Date(b.fechaUltimaEdicion) - new Date(a.fechaUltimaEdicion))
            .map(adicional => ({
                ...adicional,
                fechaId: `a-f-${adicional.id}`,
                usuarioId: `a-u-${adicional.id}`,
                adicionalId: `a-o-${adicional.id}`,
            }));

        state.cambios = brief.cambios
            .sort((a, b) => new Date(b.fechaUltimaEdicion) - new Date(a.fechaUltimaEdicion))
            .map(cambio => ({
                ...cambio,
                fechaId: `c-f-${cambio.id}`,
                usuarioId: `c-u-${cambio.id}`,
                observacionesId: `c-o-${cambio.id}`,
            }));

        state.muestras = brief.muestras
            .sort((a, b) => new Date(b.fechaRegistro) - new Date(a.fechaRegistro))
            .map(muestra => ({
                ...muestra,
                isValidado: moment(muestra.fechaValidacion).format('YYYY-MM-DD') != '1900-01-01',
                tieneEspecificaciones: muestra.especificaciones.length != 0
            }));

        state.originales = brief.originales
            .sort((a, b) => new Date(b.fechaRegistro) - new Date(a.fechaRegistro))        
            .map(original => ({
                ...original,
                isValidado: moment(original.fechaValidacion).format('YYYY-MM-DD') != '1900-01-01',
                tieneCambios: original.cambios.length != 0
            }));

        state.imagenes = brief.imagenes;
        state.links = brief.links;
        state.marcas = brief.marcas;
        state.presupuestosInternos = brief.presupuestosInternos;
        state.usuarios = brief.usuarios;

        if (brief.tiposDisenios) {
            brief.tiposDisenios.forEach(t => {
                let tipoDisenio = state.tiposDisenios.find(item => item.nombre.trim() == t.tipoDisenio.trim());

                if (tipoDisenio) {
                    tipoDisenio.selected = true;
                } else {
                    state.tiposDisenios.push({
                        id: t.tipoDisenioId,
                        nombre: t.tipoDisenio,
                        mecanicaPromocional: t.mecanicaPromocional,
                        selected: true
                    })
                }
            });

            state.tiposDisenios = state.tiposDisenios
                .sort(function(a, b){
                    let x = a.nombre.toLowerCase().trim();
                    let y = b.nombre.toLowerCase().trim();
                    if (x < y) { 
                        return -1; 
                    }
                    if (x > y) {
                        return 1;
                    }
                    return 0;
                });
        }

        state.briefDatos = brief;
        state.briefDatos.id = state.id;
    },
    'ADD_MUESTRA' (state, muestra) {
        muestra.fechaValidacion = '1900-01-01';
        muestra.usuarioValidacion = '';
        muestra.observacionesValidacion = '';
        muestra.especificaciones = '';

        state.muestras.unshift({
            ...muestra,
            isValidado: false,
            tieneEspecificaciones: false
        });
    },
    'REMOVE_MUESTRA' (state, muestraId) {
        let itemKey = state.muestras
            .findIndex(muestra => muestra.id == muestraId);

        if (itemKey != -1) {
            state.muestras.splice(itemKey, 1);
        }
    },
    'ADD_ORIGINAL' (state, original) {
        original.fechaValidacion = '1900-01-01';
        original.usuarioValidacion = '';
        original.observacionesValidacion = '';
        original.cambios = [];
        
        if ((/true/i).test(original.isValidado)) {
            original.fechaValidacion = new Date();
            original.usuarioValidacion = original.usuario;
            original.observacionesValidacion = '';
        }

        state.originales.unshift({
            ...original,
            tieneCambios: false
        });
    },
    'REMOVE_ORIGINAL' (state, originalId) {
        let itemKey = state.originales
            .findIndex(original => original.id == originalId);

        if (itemKey != -1) {
            state.originales.splice(itemKey, 1);
        }
    },
    'ACTUALIZAR_VALIDACION_MUESTRA'(state, params) {
        let muestra = state.muestras.find(t => t.id == params.briefMuestraId);

        if (muestra) {
            muestra.fechaValidacion = moment(new Date()).format('YYYY-MM-DD HH:mm');
            muestra.usuarioValidacion = params.usuario;
            muestra.isValidado = true;

            muestra.especificaciones = params.especificaciones;
            muestra.tieneEspecificaciones = params.especificaciones.length != 0;
        }
    },
    'ACTUALIZAR_ESPECIFICACIONES_MUESTRA'(state, params) {
        let muestra = state.muestras.find(t => t.id == params.briefMuestraId);

        if (muestra) {
            muestra.especificaciones = params.especificaciones;
            muestra.tieneEspecificaciones = params.especificaciones.length != 0;
        }
    },
    'ACTUALIZAR_VALIDACION_ORIGINAL'(state, params) {
        let original = state.originales.find(t => t.id == params.briefOriginalId);

        if (original) {
            original.fechaValidacion = moment(new Date()).format('YYYY-MM-DD HH:mm');
            original.usuarioValidacion = params.usuario;
            original.isValidado = true;
        }
    },
    'ADD_SOLICITUD_CAMBIOS_ORIGINAL' (state, solicitudCambios) {
        let original = state.originales.find(t => t.id == solicitudCambios.briefOriginalId);

        if (original) {
            original.cambios.push(solicitudCambios);
            
            original.tieneCambios = true;
        }
    },
    'DELETE_SOLICITUD_CAMBIOS_ORIGINAL' (state, params) {
        let original = state.originales.find(t => t.id == params.briefOriginalId);

        if (original) {
            let itemKey = original.cambios
                .findIndex(t => t.id == params.solicitudCambiosId);

            if (itemKey != -1) {
                original.cambios.splice(itemKey, 1);
            }

            original.tieneCambios = original.cambios.length != 0;
        }
    },
    'SOLUCIONAR_SOLICITUD_CAMBIOS_ORIGINAL' (state, params) {
        let original = state.originales.find(t => t.id == params.briefOriginalId);

        if (original) {
            let solicitudCambios = original.cambios.find(t => t.id == params.solicitudCambiosId);

            if (solicitudCambios) {
                solicitudCambios.usuarioSolucion = params.usuario;
                solicitudCambios.fechaSolucion = new Date();
                solicitudCambios.solucionado = true;
            }
        }
    },

    'INICIALIZAR_RPT_CAMBIOS'(state) {
        state.briefCambios = {};
    },
    'SET_RPT_CAMBIOS'(state, briefCambios) {
        state.briefCambios = briefCambios;

        state.briefCambios.cambios = state.briefCambios.cambios
            .sort((a, b) => new Date(b.fechaUltimaEdicion) - new Date(a.fechaUltimaEdicion));
    }
};

const getters = {
    getField,

    briefCambios (state) {
        return state.briefCambios;
    },
    briefDatos (state) {
        return state.briefDatos;
    }
};

const actions = {
    getBrief ( { commit }, briefId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', briefId);

            apiAxios.get(`tipos-disenios/list`)
                .then(res => {
                    commit('SET_TIPOS_DISENIOS', res.data);

                    return apiAxios.get(`briefs/${briefId}`);         
                })
                .then(res => {
                    commit('SET_BRIEF', res.data);
                    resolve();
                })
                .catch(error => reject(error))
        }, error => {
            reject(error);
        })
    },
    addMuestra( { commit }, muestra ) {
        return new Promise((resolve, reject) => {
            // console.log(muestra);
            apiAxios.post(`briefs/${muestra.briefId}/muestras`, muestra) 
                .then(res => {
                    muestra.id = res.data.id;
                    commit('ADD_MUESTRA', muestra);
                    resolve();
                })
                .catch(error => reject(error))
        }, error => {
            reject(error);
        })
    },
    removeMuestra( { commit }, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`briefs/${params.briefId}/muestras/${params.muestraId}/delete`) 
                .then(res => {
                    commit('REMOVE_MUESTRA', params.muestraId);
                    resolve();
                })
                .catch(error => reject(error))
        }, error => {
            reject(error);
        })
    },
    addOriginal( { commit }, original ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`briefs/${original.briefId}/originales`, original) 
                .then(res => {
                    original.id = res.data.id;
                    commit('ADD_ORIGINAL', original);
                    resolve();
                })
                .catch(error => reject(error))
        }, error => {
            reject(error);
        })
    },
    removeOriginal( { commit }, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`briefs/${params.briefId}/originales/${params.originalId}/delete`) 
                .then(res => {
                    commit('REMOVE_ORIGINAL', params.originalId);
                    resolve();
                })
                .catch(error => reject(error))
        }, error => {
            reject(error);
        })
    },
    actualizarValidacionMuestra( { rootState, commit }, params) {
        return new Promise((resolve, reject) => {
            params.usuario = '';

            if (rootState.user) {
                if (rootState.user.nombreCompleto) {
                    params.usuario = rootState.user.nombreCompleto.trim();
                }
            }

            commit('ACTUALIZAR_VALIDACION_MUESTRA', params);
            resolve();
        }, error => {
            reject(error);
        })
    },
    actualizarEspecificacionesMuestra( { commit }, params) {
        return new Promise((resolve, reject) => {
            commit('ACTUALIZAR_ESPECIFICACIONES_MUESTRA', params);
            resolve();
        }, error => {
            reject(error);
        })
    },    
    actualizarValidacionOriginal( { rootState, commit }, briefOriginalId) {
        return new Promise((resolve, reject) => {
            let params = {
                briefOriginalId,
                usuario: ''
            }

            if (rootState.user) {
                if (rootState.user.nombreCompleto) {
                    params.usuario = rootState.user.nombreCompleto.trim();
                }
            }

            commit('ACTUALIZAR_VALIDACION_ORIGINAL', params);
            resolve();
        }, error => {
            reject(error);
        })
    },
    addSolicitudCambiosOriginal( { commit }, solicitudCambios ) {
        return new Promise((resolve, reject) => {
            commit('ADD_SOLICITUD_CAMBIOS_ORIGINAL', solicitudCambios);
            resolve();
        })
    },
    deleteSolicitudCambiosOriginal( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('DELETE_SOLICITUD_CAMBIOS_ORIGINAL', params);
            resolve();
        })
    },
    solucionarSolicitudCambiosOriginal( { rootState, commit }, params ) {
        return new Promise((resolve, reject) => {
            params.usuario = '';

            if (rootState.user) {
                if (rootState.user.nombreCompleto) {
                    params.usuario = rootState.user.nombreCompleto.trim();
                }
            }

            commit('SOLUCIONAR_SOLICITUD_CAMBIOS_ORIGINAL', params);
            resolve();
        })
    },
    getRptBriefCambios ( { commit }, briefId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_CAMBIOS');

            apiAxios.get(`briefs/${briefId}/reporte-cambios`) 
                .then(res => {
                    commit('SET_RPT_CAMBIOS', res.data);
                    resolve();
                })
                .catch(error => reject(error))
        }, error => {
            reject(error);
        })
    },        
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}